var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaperPlaneWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PaperPlane"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3343 3.42206L2.46559 19.2564C2.3919 19.3898 2.36059 19.5425 2.37583 19.6941C2.39106 19.8457 2.45212 19.9891 2.55086 20.1051C2.64961 20.2212 2.78137 20.3044 2.92859 20.3437C3.07581 20.383 3.23151 20.3766 3.37496 20.3252L11.7375 17.3439C11.8998 17.2783 12.0814 17.2783 12.2437 17.3439L20.6062 20.3252C20.7497 20.3766 20.9054 20.383 21.0526 20.3437C21.1998 20.3044 21.3316 20.2212 21.4303 20.1051C21.5291 19.9891 21.5901 19.8457 21.6054 19.6941C21.6206 19.5425 21.5893 19.3898 21.5156 19.2564L12.6468 3.42206C12.582 3.30484 12.4869 3.20713 12.3715 3.13908C12.2561 3.07104 12.1246 3.03516 11.9906 3.03516C11.8566 3.03516 11.7251 3.07104 11.6097 3.13908C11.4943 3.20713 11.3992 3.30484 11.3343 3.42206Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9902 17.25V11.25",
    stroke: "#3030AD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaperPlaneWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paperPlaneWhite.c9a353292ea3f2e484baa6b6f945ed23.svg";